import { ApiCard } from '../openapi';

export function isCardMatch(query: string, card: ApiCard) {
  // Search by card ID
  if (card.id === query) return true;

  // Search by holder ID
  if (card.cardHolderId === query) return true;

  // Search by card name
  if (card.name?.toLowerCase().includes(query)) return true;

  return false;
}
